import { useEffect } from "preact/hooks";
import { ApproveEntityStatus } from "@kase/my-marathon-communication";
import { getBudgetApproval, useApp } from "~/core";

const IGNORE_STATUS = ApproveEntityStatus.UNRECOGNIZED;

const useBudgetApproval = (budgetId: string | null | undefined) => {
    const { api } = useApp();
    const budget = api.budget.allBudgets.value.find((b) => b.id === budgetId);
    const company = budget
        ? api.project.getWithCompany(budget.project)?.company
        : undefined;

    useEffect(() => {
        if (!budget || !company) {
            return;
        }

        api.approve.getOrLoadBudget(
            budget._id,
            {
                companies: [company],
                status: IGNORE_STATUS,
            },
            true,
        );

        return api.approve.approval.listenBudgets({
            parent: budget._id,
            company,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [budgetId, company]);

    const state = getBudgetApproval(
        budgetId,
        api.budget.allBudgets.value,
        api.approve.approval.budgets.value,
    );
    const approve =
        api.approve.budgets.value.find((a) => a._id.toString() === budgetId) ??
        null;

    return {
        status: state.status,
        approve,
        internal: {
            ...state.internal,
        },
        external: {
            ...state.external,
        },
    };
};

export default useBudgetApproval;
